<template>
    <span></span> <!-- <button class="btn btn-info btn-sm right-sidebar-toggle" v-tooltip="trans('general.help')" @click="$emit('clicked')"><i class="fas fa-question-circle"></i></button>  -->
</template>

<script>
	export default {
	}
</script>